/**
 * Create store system patch divecePatch - dlpDBPatch
 * Central Management > SW 업데이트 > DLP DB
 *
 * @since 2020-04-20
 * @author tams_dev2
 */
import {CmApiPrefix as cmApiPrefix} from '~/utils/restApi'
import {formatDate} from '~/utils/date'
import Moment from 'moment'
import {getCodeJsonRow} from '~/utils/device-common'

export const state = () => ({
  apiUrl: {
    onlineUpdateStatus: `${cmApiPrefix}/contents/update`, // 날짜 별 패치 내역 device_contents_update_db_type : 2
    onlineUpdateDevice: `${cmApiPrefix}/contents/update/device`, // 장비 별 패치 내역 { 장비 ID , type }
    onlineAutoUpdateConfig: `${cmApiPrefix}/contents/update/auto`, // auto Update Config device_contents_update_db_type : 2
    onlineAutoUpdateApply: `${cmApiPrefix}/contents/update/apply`, // apply Execute
    onlineAutoUpdateCancel: `${cmApiPrefix}/contents/update/cancel` // auto Update cancel Config
  },
  patchHistoryList: [], // 날짜 별 패치 내역
  patchDetailInfoList: [], // 날짜 별 상세 패치 내역
  devicePatchHistoryList: [], // 장비 별 패치 내역
  deviceDetailInfoList: [], // 장비 별 상세 패치 내역
  updateType: { // 'FILE' or 'ONLINE'
    type: 'FILE'
  },
  // 결과 code key
  resultTypeKey: 'application_db_type',
  typeParam: {},
  /* 컨텐츠 DB 종류
    (IPS 컨텐츠 DB: 1, 애플리케이션 제어 DB: 2, 웹 필터 DB: 3, 안티 바이러스 DB: 4, 블랙리스트 DB: 5, DLP DB: 6,
     APT 정책: 7, 파일 유형 제어 DB: 8, SSL 예외 목록: 9, 사설인증서 DB: 10, 디바이스 정책 DB: 11)
   */
  contentsUpdateDbType: 2,
  /* 컨텐츠 DB 종류가 웹 필터 DB(3) 또는 디바이스 정책 DB(11)인 경우만 사용하는 속성
    (integer)(range=1-4)
     웹 필터 DB 종류(Anonymizer: 1, SafeNET: 2, 클라우드 악성 URL: 3, Categorized URL: 4)
     디바이스 DB 종류(CUS: 1, 단말포탈: 2)
   */
  contentsUpdateSubType: void 0,
  // 패치 작업 추가 관련
  deviceIdList: [], // 패치 작업 대상 장비 리스트
  upLoadFile: null,
  upLoadFileLight: null,
  errorMessage: null,
  onlineUrl: '',
  detailResultList: [],

  // applicationDbType: 2, // 애플리케이션 DB Type 2로 고정
  autoUpdateConfig: {
    enable: 0, // AutoUpdate 사용 여부 0:사용 안함, 1: 사용함
    url: '', // 업데이트 서버 주소
    daysStr: [0, 0, 0, 0, 0, 0, 0], // 일월화수목금토 0:미체크, 1:체크
    deviceList: [], // 자동 업데이트 장비 리스트
    deviceListName: '', // 대상 장비 이름
    hourMin: Moment('0000', 'Hmm').format(),
    hour: '0',
    min: '0'
  },
  selectTabName: '' // 기본적으로 선택되어야 할 탭 이름
})

export const mutations = {
  setSelectTabName (state, tabName) {
    state.selectTabName = tabName
  },
  setOptions (state) {
    state.detailResultList = _.map(getCodeJsonRow(state.resultTypeKey), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  setContentsUpdateDbType (state, data) {
    state.contentsUpdateDbType = _.cloneDeep(data)
    state.typeParam.device_contents_update_db_type = state.contentsUpdateDbType
  },
  setContentsUpdateSubType (state, data) {
    if (_.isNil(data)) {
      state.contentsUpdateSubType = void 0
      delete state.typeParam.device_contents_update_db_sub_type
    } else {
      state.contentsUpdateSubType = _.cloneDeep(data)
      state.typeParam.device_contents_update_db_sub_type = state.contentsUpdateSubType
    }
  },
  setAutoUpdateConfig (state, data) {
    const item = _.cloneDeep(data)
    /*
    item = {
      contents_auto_update_yn: 1, // AutoUpdate 사용 여부 0:사용 안함, 1: 사용함
      contents_update_server: 'welcome to jiniworld', // 서버 주소
      contents_update_week: [0, 1, 0, 0, 1, 0, 0], // 일월화수목금토
      contents_update_date: '13:00', // 시:분
      contents_device_id_list: [5] // 장비 ID 리스트
      contents_device_uname: 'select item name'
    }
     */
    const config = {}
    config.enable = item.contents_auto_update_yn
    config.url = item.contents_update_server
    if (item.contents_update_week.length > 0) {
      config.daysStr = _.map(_.toArray(item.contents_update_week), _.parseInt) // arr
    } else {
      config.daysStr = [0, 0, 0, 0, 0, 0, 0]
    }
    config.hour = (item.contents_update_date.indexOf(':') > -1) ? item.contents_update_date.split(':')[0] : '0'
    config.min = (item.contents_update_date.indexOf(':') > -1) ? item.contents_update_date.split(':')[1] : '0'
    if (item.contents_update_date.indexOf(':') > -1) {
      config.hourMin = Moment().set('hour', Number(config.hour)).set('minute', Number(config.min)).format()
    } else {
      // Blank
      config.hourMin = Moment('0000', 'Hmm').format()
    }
    config.deviceList = item.contents_device_id_list
    config.deviceListName = item.contents_device_uname

    // state.autoUpdateConfig = _.cloneDeep(config)
    state.autoUpdateConfig = config
  },
  setPatchHistoryList (state, data) {
    state.patchHistoryList = _.cloneDeep(data)
  },
  setPatchDetailList (state, data) {
    state.patchDetailInfoList = _.cloneDeep(data)
  },
  // setPatchDetailInfo (state, data) {
  //   let item = _.cloneDeep(data)
  //   /*
  //   if (item === null) {
  //     // 날짜 별 상세 패치 현황
  //     item = [{
  //       device_contents_update_id: 1,
  //       device_contents_update_type: 1,
  //       device_contents_update_ver_name: 'v 1.0.1',
  //       device_contents_update_file_name: 'jiniworld.tar',
  //       device_contents_update_result_type: 0, // 결과 유형 0: 준비, 1~99: 에러 코드, 100: 성공",
  //       device_contents_update_err_set: 'Error',
  //       device_id: 1,
  //       device_uname: 'jiniworld'
  //     }]
  //   }
  //   */
  //   state.patchDetailInfoList = item
  // },
  setDevicePatchHistoryList (state, data) {
    state.devicePatchHistoryList = _.cloneDeep(data)
  },
  setDevicePatchDetailList (state, data) {
    state.deviceDetailInfoList = _.cloneDeep(data)
  },
  // setDevicePatchDetailInfo (state, data) {
  //   let item = _.cloneDeep(data)
  //   /*
  //   if (item === null) {
  //     item = [{ // 날짜 별 상세 패치 현황
  //       device_contents_update_id: 1,
  //       device_contents_update_type: 1,
  //       device_contents_update_ver_name: 'v 1.0.1',
  //       device_contents_update_file_name: 'jiniworld.tar',
  //       device_contents_update_result_type: 0, // 결과 유형 0: 준비, 1~99: 에러 코드, 100: 성공",
  //       device_contents_update_err_set: 'Error',
  //       device_id: 1,
  //       device_uname: 'jiniworld'
  //     }]
  //   }
  //   */
  //   state.deviceDetailInfoList = item
  // },
  clearPatchHistoryData (state) {
    state.patchHistoryList = [] // 날짜 별 패치 내역
    state.patchDetailInfoList = [] // 날짜 별 상세 패치 내역
    state.devicePatchHistoryList = [] // 장비 별 패치 내역
    state.deviceDetailInfoList = [] // 장비 별 상세 패치 내역
    state.detailResultList = []
  },
  setPatchDeviceData (state, data) {
    state.deviceIdList = _.cloneDeep(data)
  },
  clearPatchDeviceData (state) {
    state.updateType = {
      type: 'FILE'
    }
    state.deviceIdList = []
    state.onlineUrl = ''
    // state.upLoadFile = null
  },
  setErrorMessage (state, data) {
    state.errorMessage = data.msg || ''
  },
  setFileUpload (state, data) {
    state.upLoadFile = data
  },
  setFileUploadLight (state, data) {
    state.upLoadFileLight = data
  }
  // Mutation End
}

export const actions = {
  async getPatchHistoryList ({commit, state}, {loading}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineUpdateStatus, {params: state.typeParam, loading: loading}) // obj})
    if (code === 'ok') {
      commit('setPatchHistoryList', result)
    }
    return code
  },
  async getPatchHistoryDetailList ({commit, state}, {deviceId}) {
    // 날짜 별 상세 정보
    const url = `${state.apiUrl.onlineUpdateStatus}/${deviceId}`
    const res = await this.$axios.$get(url, {params: state.typeParam, loading: false})
    // 이력 남기기
    // const url = `${state.apiUrl.onlineUpdateStatus}/${deviceId}`
    // const {code, result} = await this.$axios.$get(url, {params: state.typeParam, loading: false})
    if (res.code === 'ok') {
      commit('setPatchDetailList', res.result)
    }
    return res.code
  },
  async getDevicePatchHistoryList ({commit, state}, {loading}) {
    // 장비 별 정보
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineUpdateDevice, {params: state.typeParam, loading: loading})
    if (code === 'ok') {
      commit('setDevicePatchHistoryList', result)
    }
    return code
  },
  async getDevicePatchHistoryDetailList ({commit, state}, {deviceId}) {
    // 장비 별 상세 정보
    const url = `${state.apiUrl.onlineUpdateDevice}/${deviceId}`
    const res = await this.$axios.$get(url, {params: state.typeParam, loading: false})
    // 이력 남기기
    // const url = `${state.apiUrl.onlineUpdateDevice}/${deviceId}`
    // const {code, result} = await this.$axios.$get(url, {params: state.typeParam})
    if (res.code === 'ok') {
      commit('setDevicePatchDetailList', res.result)
    }
    return res.code
  },
  async getAutoUpdateConfig ({commit, state}) {
    // 자동 업데이트 설정 정보
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineAutoUpdateConfig, {params: state.typeParam})
    if (code === 'ok') {
      commit('setAutoUpdateConfig', result)
    }
    return code
  },
  async parseTimeData ({commit, state}, data) {
    state.autoUpdateConfig.hour = formatDate(data, 'HH')
    state.autoUpdateConfig.min = formatDate(data, 'mm')
  },
  async setDevicePatchData ({commit, state}, isLoading = true) {
    let data = { code: 'nok', result: { msg: `Unknown Update Type: ${state.updateType.type}` } }
    const config = {loading: isLoading, successAlert: false, failAlert: false}
    let url = state.apiUrl.onlineUpdateStatus + '?device_contents_update_db_type=' + state.contentsUpdateDbType

    if (!_.isNil(state.contentsUpdateSubType)) {
      url += '&device_contents_update_db_sub_type=' + state.contentsUpdateSubType
    }
    const formData = new FormData()
    formData.append('device_id_list', JSON.stringify(state.deviceIdList))

    if (state.updateType.type === 'FILE') {
      formData.append('device_contents_update_type', 1) // 1: File, 2:TAMS
      formData.append('device_contents_update_file_name', state.upLoadFile.formData.get('file'))
      // Light DB
      if (
        state.contentsUpdateDbType === 1 || // ips contents db
        (state.contentsUpdateDbType === 3 && state.contentsUpdateSubType === 2) // webfilter contenct db && safenet
      ) {
        formData.append('device_contents_update_file_name_2', state.upLoadFileLight.formData.get('file'))
      }
      data = await this.$axios.$put(url, formData, config)
    } else if (state.updateType.type === 'ONLINE') {
      formData.append('device_contents_update_type', 2) // 1: File, 2:TAMS
      formData.append('device_contents_update_server', state.onlineUrl)

      data = await this.$axios.$put(url, formData, config)
    }

    if (data.code === 'ok') {
      return true
    } else {
      commit('setErrorMessage', data.result)
      return false
    }
  },
  setUrlInputHandler ({commit, state}, value) {
    state.onlineUrl = value
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      const params = {}
      let url = ''
      if (type === 'apply') {
        msg = {applyMsg: false, loading: false, successAlert: false, failAlert: false}
        params.contents_auto_update_yn = state.autoUpdateConfig.enable
        params.contents_update_server = state.autoUpdateConfig.url
        const arr = state.autoUpdateConfig.daysStr
        let dayStr = ''
        arr.forEach((v) => {
          dayStr += '' + v
        })
        params.contents_update_week = dayStr
        params.contents_update_date = state.autoUpdateConfig.hour.concat(':').concat(state.autoUpdateConfig.min)
        params.contents_device_id_list = state.autoUpdateConfig.deviceList

        url = state.apiUrl.onlineAutoUpdateConfig + '?device_contents_update_db_type=' + state.contentsUpdateDbType
        if (!_.isNil(state.contentsUpdateSubType)) {
          url += '&device_contents_update_db_sub_type=' + state.contentsUpdateSubType
        }
      } else {
        msg = {cancelMsg: true, loading: false}
        url = state.apiUrl.onlineAutoUpdateCancel
      }
      const data = await this.$axios.$put(url, (type === 'apply' ? params : null), msg)

      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async setApplyExecute ({state}) {
    try {
      const result = await this.$axios.$put(state.apiUrl.onlineAutoUpdateApply, null, {applyMsg: true, loading: false})
      if (result.code === 'ok') {
        return result
      }
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
  // action End
}

export const getters = {}
